import React from "react";
import { useNavigate } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="max-w-[560px] mx-auto px-4 py-28 text-center">
      <Seo title="Page not found — Namable" description="The page you're looking for doesn't exist." path="/404" />
      <p className="font-display text-[64px] font-extrabold text-gradient leading-none">404</p>
      <h1 className="font-display text-[24px] font-extrabold text-ink mt-4">This page took a different name</h1>
      <p className="text-ink-muted mt-2">Let's get you back to naming.</p>
      <Button onClick={() => navigate("/generate")} className="mt-6 h-12 px-6 rounded-xl bg-brand hover:bg-brand-dark text-white font-bold btn-glow">
        Go to generator
      </Button>
    </div>
  );
}
